import React, { useCallback, useContext, useState } from "react";
import { SvgIconStyles, ProfileCardStyles } from './Style'
import { Chip } from "components/Form";
import { Divider, IconButton, SvgIcon, Typography } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { bg } from "styles/theme";
import { ReactComponent as VisibilityIcon } from 'assets/icons/Visibility.svg';
import { useNavigate } from "react-router-dom";
import { app } from "router/routes";
import { AssessmentsContext } from "./AssessmentsContext";
import { profiles } from "keys";
import { useSelector } from "react-redux";

const ProfileCard = (props) => {
    const { profile, index, label, ratingIndex, ratingKey } = props
    const { profileAcordions, setProfileAcordions } = useContext(AssessmentsContext)
    const { brokenDisplay } = useSelector(state => state.general)

    const goReport = useCallback((assessment_id) => {
        const width = 1000
        const height = 800
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
        window.open(`${app.assessments}/${assessment_id}`, 'newWindow', `width=${width},height=${height},top=${top},left=${left}`);
    }, [])

    const updateAcordionExpand = useCallback((index) => {
        let nProfileAcordions = [...profileAcordions]
        nProfileAcordions[index] = !nProfileAcordions[index]
        setProfileAcordions(nProfileAcordions)
    }, [profileAcordions])

    const { test_takers } = profile
    const isExpand = profileAcordions[index]

    return (
        <ProfileCardStyles height={!isExpand ? 23 : 500} key={index} expanded={isExpand}>
            <div
                aria-controls={`panel${index}-content`}
                id="panel2-header"
                className="profile-card-header"
            >
                <div className="profile-item-name">
                    {label}
                    <div className="wrap-chip">
                        <Chip {...profiles[ratingIndex]}>{profiles[ratingIndex][ratingKey]}</Chip>
                    </div>
                </div>
                <div className="wrap-expand-header">
                    <div className="test-taker-list-title">{`${test_takers.length} תלמידים`}</div>
                    <IconButton sx={{ width: 25, height: 25 }} disabled={!test_takers.length}>
                        {isExpand ?
                            <ExpandLess fontSize="small" onClick={() => updateAcordionExpand(index)} /> :
                            <ExpandMore fontSize="small" onClick={() => updateAcordionExpand(index)} />}
                    </IconButton>
                </div>
            </div>
            {isExpand &&
                <div className="test-taker-list">
                    {test_takers.map((test_taker, _index) =>
                        <React.Fragment>
                            <div key={_index} className="test-taker-item">
                                <span className={`${brokenDisplay && 'blurred2'}`}>
                                    {test_taker.name}
                                </span>
                                <IconButton onClick={() => goReport(test_taker.assessment_id)}>
                                    <SvgIconStyles component={VisibilityIcon} inheritViewBox />
                                </IconButton>
                            </div>
                            {_index != test_takers.length - 1 &&
                                <Divider sx={{ borderColor: bg }} />}
                        </React.Fragment>
                    )}
                </div>}
        </ProfileCardStyles>
    )
}

export default ProfileCard